/**
 * Crea la animación de los reversos de las cartas
 * @param {*} scene
 */
export function crearReversosAnimados(scene) {
  // Animación Revelar reverso 1
  scene.anims.create({
    key: "reversoCarta1RevelandoAnimado",
    frames: scene.anims.generateFrameNumbers("reversoCarta1Revelando", {
      start: 0,
      end: 2,
    }),
    frameRate: 20,
    repeat: -1,
  });

  // Animación Espiar reverso 1
  scene.anims.create({
    key: "reversoCarta1EspiandoAnimado",
    frames: scene.anims.generateFrameNumbers("reversoCarta1Espiando", {
      start: 0,
      end: 6,
    }),
    frameRate: 10,
    repeat: -1,
  });
}
